import { ErrorBoundary, TopBar } from '../components'
import { ErrorProvider, UserInfoProvider } from '../contexts'
import { AppRoutes } from '../routes'
import { areAdminToolNewsUsed, isAdminToolUsed } from '../utils'
import { AppWrapper } from './app-wrapper'

export const App = () => {
  /*
  Put line
  REACT_APP_USE_ADMIN_TOOL='true'
  in .env file if you want to test admin tool locally.
  On Admintool's side, configure .env there to point files on this side, example
  LOCAL_CLIENT_TRANSLATIONS_FOLDER=C:/your local sub folders/lotta-front/public/translations/
  LOCAL_CLIENT_LINKS_FILE=client-links.json
  LOCAL_CLIENT_NEWS_FILE=client-news.json
  LOCAL_CLIENT_TEXTS_FILE=client-translations.json
  LOCAL_COMMON_TRANSLATIONS_FOLDER=C:/your local sub folders//lotta-front/src/translations_new/
  LOCAL_COMMON_TEXTS_FILE=translations.json 
  */
  const useAdminTool = isAdminToolUsed()
  const useAdminToolNews = areAdminToolNewsUsed()
  const showNews = useAdminTool && useAdminToolNews

  return (
    <ErrorBoundary>
      <AppWrapper
        useAdminTool={useAdminTool}
        useAdminToolNews={useAdminToolNews}
      >
        <UserInfoProvider useAdminTool={useAdminTool}>
          <ErrorProvider useAdminTool={useAdminTool}>
            <TopBar useAdminTool={useAdminTool} />
            <AppRoutes showNews={showNews} />
          </ErrorProvider>
        </UserInfoProvider>
      </AppWrapper>
    </ErrorBoundary>
  )
}
